module.exports = "https://bin.bnbstatic.com/_next/static/images/NPXS_landing-CH-abd4aa4fd665cc978722dabbc10fb4fd.jpg";